/* «Перевести в расширенное» — второй ряд плашки карточки (`.lpsAction`). Плашка стоит в
   `.tgzone`, но СНАРУЖИ пузыря `.tg`, поэтому фирменные классы кнопок здесь законны: это наш
   орган рядом с чужим клиентом, а не часть клиента (docs/ui-design.md §6). */

.wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  width: 100%;
}

.row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
